export default "__VITE_ASSET__DOe9PP77__"